import Component from "../abstracts/Component";

export default class LoginFormComponent extends Component {
  get SELECTORS() {
    return {
      headerLoginForm: 'headerLoginForm',
      cartLoginForm: 'cartLoginForm',
      loginLoginForm: 'LoginForm',
      loginPopupForm: 'loginPopupForm',
      emailError: "#emailError",
      passwordError: "#passwordError",
      email: "input[type='email']",
      password: "input[type='password']",
      errorMessage: "[data-error-message]",
    };
  }

  get ERRORS_ATTRIBUTES() {
    return {
      emailBlank: "data-error-email-blank",
      passwordBlank: "data-error-password-blank",
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  readDOM() {
    return {
      headerLoginForm: document.getElementById(this.SELECTORS.headerLoginForm),
      cartLoginForm: document.getElementById(this.SELECTORS.cartLoginForm),
      LoginForm: document.getElementById(this.SELECTORS.loginLoginForm),
      loginPopupForm: document.getElementById(this.SELECTORS.loginPopupForm),
      email: document.getElementById(this.SELECTORS.email),
      password: document.getElementById(this.SELECTORS.password),
      emailError: this.$component.querySelector(this.SELECTORS.emailError),
      passwordError: this.$component.querySelector(
        this.SELECTORS.passwordError,
      ),
    };
  }

  checkFormValidity(event) {
    const currentTarget = this.dom[event.target.id];
    let isValid = true;
    const email = this.dom[event.target.id].querySelector(this.SELECTORS.email);
    const errorMessage = this.dom[event.target.id].querySelector(this.SELECTORS.errorMessage);
    const emailWrapper = email.closest('.custom-input');
    const password = this.dom[event.target.id].querySelector("input[name='j_password']");
    const passwordWrapper = password.closest('.custom-input');
    const emailError = this.dom[event.target.id].querySelector(this.SELECTORS.emailError);
    const passwordError = this.dom[event.target.id].querySelector(this.SELECTORS.passwordError);

    this.MESSAGES = {
      email: {
        blank: currentTarget.getAttribute(this.ERRORS_ATTRIBUTES.emailBlank),
      },
      password: {
        blank: currentTarget.getAttribute(this.ERRORS_ATTRIBUTES.passwordBlank),
      },
    };

    if (!password.value) {
      isValid = false;
      passwordError.textContent = this.MESSAGES.password.blank;
      passwordWrapper?.classList.add('error');
      password.setAttribute("aria-invalid", "true");
      password.setAttribute("aria-label",this.MESSAGES.password.blank);
      password.focus();
    } else {
      passwordError.textContent = "";
      password.setAttribute("aria-invalid", "false");
      password.removeAttribute("aria-label");
      password.closest('.custom-input')?.classList.remove('error');
    }

    if (!email.value) {
      isValid = false;
      emailError.textContent = this.MESSAGES.email.blank;
      emailWrapper?.classList.add('error');
      email.setAttribute("aria-invalid", "true");
      email.setAttribute("aria-label",this.MESSAGES.email.blank);
      email.focus();
    } else {
      emailError.textContent = "";
      email.setAttribute("aria-invalid", "false");
      email.removeAttribute("aria-label");
      emailWrapper?.classList.remove('error');
    }

    if (!isValid) {
      event.preventDefault();
    }
  }

  bindEvents() {
    this.dom.headerLoginForm && this.dom.headerLoginForm.addEventListener("submit", this.checkFormValidity.bind(this));
    this.dom.cartLoginForm && this.dom.cartLoginForm.addEventListener("submit", this.checkFormValidity.bind(this));
    this.dom.LoginForm && this.dom.LoginForm.addEventListener("submit", this.checkFormValidity.bind(this));
    this.dom.loginPopupForm && this.dom.loginPopupForm.addEventListener("submit", this.checkFormValidity.bind(this));
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    this.bindEvents();
  }
}
